import React, { useState } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './SearchByLocation.css';
import { Container, Row, Col, Form, Card, Button, } from 'react-bootstrap';
import bannerImage from '../assets/images/banner.png';
import img1 from '../assets/images/img (1).png';
import img2 from '../assets/images/img (2).png';
import img4 from '../assets/images/img (4).png';
import img5 from '../assets/images/img (5).png';
import po from '../assets/images/po.png';

const images = [
    bannerImage,
    img1,
    img2,
    img4,
    img5,
];

// Custom Arrows
const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      {/* You can use an icon instead of text */}
      <span style={{ display: "none" }}>Next</span>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      {/* You can use an icon instead of text */}
      <span style={{ display: "none" }}>Prev</span>
    </div>
  );
};


const GetDetailsByName = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const thumbnailSettings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  focusOnSelect: true,
  arrows: true,
  afterChange: (current) => setActiveIndex(current),
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1 },
    },
  ],
};


    return (
        <>
            <div className="home-container1">
                <div
                    className="banner-section"
                    style={{ backgroundImage: `url(${bannerImage})` }}
                >
                    <div className="banner-overlay"></div>
                    <div className="banner-content">
                        <h1>Shashank House</h1>
                        <p className="breadcrumb-text">
                            <span>Miyapur</span> <span className="arrow">&rarr;</span> <span>Shashank House</span>
                        </p>
                    </div>
                </div>
            </div>
            <section className="">
                <div className="carousel-wrapper ">
                    <Container className="mt-4">
                        <div className="main-preview sectionTwo">
                            <img src={images[activeIndex]} alt="Main" />
                        </div>
                        <Slider {...thumbnailSettings}>
                            {images.map((img, idx) => (
                                <div key={idx} onClick={() => setActiveIndex(idx)} className="thumb-slide">
                                    <img src={img} alt={`thumb-${idx}`} className={activeIndex === idx ? 'active-thumb' : ''} />
                                </div>
                            ))}
                        </Slider>
                    </Container>
                </div>
            </section>
            <section className="aboutProperty">
                <Container >
                    <Row>
                        <Col sm={8}>
                            <div className="headingProperty">
                                <h3><b>About This Property</b></h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                            </div>
                            <div className="mt-4">
                                <h3><b>Property Overview</b></h3>
                                <img src={po} alt="" className="po" />
                            </div>
                            <div className="mt-4 mb-5">
                                <h3><b>From Our Gallery</b></h3>
                                <Row>
                                    <Col sm={5}>
                                        <img src={img1} alt="" className="po" />

                                    </Col>
                                    <Col sm={7}>
                                        <img src={img2} alt="" className="po" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={5}>
                                        <img src={img4} alt="" className="po" />

                                    </Col>
                                    <Col sm={7}>
                                        <img src={img5} alt="" className="po" />
                                    </Col>
                                </Row>


                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className="mt-5 mb-5 formData">
                                <Form>
                                    <h5>Contact the owner</h5>
                                    <hr />
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" placeholder="Name" />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control type="email" placeholder="Enter email" />
                                    </Form.Group> 
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Message</Form.Label>
                                        <Form.Control as="textarea" placeholder="Message..." rows={5} />
                                    </Form.Group> 
                                    
                                    <button  className="details-button">
                                        Submit
                                    </button>
                                </Form>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>
        </>
    );
};

export default GetDetailsByName;
